import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    foldersContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    header: {
      fontFamily: 'sans-serif',
      fontWeight: 700,
      fontSize: '13px',
      color: '#2C2D3E',
      padding: '2px',
    },
    folders: {
      margin: '0px',
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'column',
      padding: '0px',
    },
    listItem: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '4px',
      '&:hover': {
        background: 'rgba(60, 65, 154, 0.1)',
        borderRadius: '5px',
      },
      cursor: 'pointer',
    },
    activeListItem: {
      fontWeight: 700,
      color: '#3C419A',
      background: 'rgba(60, 65, 154, 0.1)',
      borderRadius: '5px',
    },
    icon: {
      position: 'relative',
      top: '2px',
      marginRight: '5px',
      color: 'rgba(44, 45, 62, 0.8)',
    },
    activeIcon: {
      color: '#3C419A',
      fill: '#3C419A',
    },
    listItemText: {
      fontFamily: 'sans-serif',
      fontWeight: 400,
      fontSize: '13px',
      color: '#2C2D3E',
      padding: '5px',
    },
    activelistItemText: {
      color: '#3C419A',
    },
    unreadMessage: {
      fontWeight: 700,
    },
  }),
);
